var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSkip = function SvgSkip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50047 4.07458L6.55859 7.64918V0.5L1.50047 4.07458Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50047 4.07458L11.5586 7.64918V0.5L6.50047 4.07458Z",
    fill: "currentColor"
  })));
};
export default SvgSkip;